import { Typography } from '@mui/material';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { Button } from 'components/DesignSystem/Button';

import classes from './DropzoneUploadError.module.scss';

export type DropzoneUploadErrorProps = {
    message: string;
    onTryAgain: () => void;
};

export const DropzoneUploadError = ({ message, onTryAgain }: DropzoneUploadErrorProps) => {
    return (
        <div className={classes.root} role={'alert'}>
            <span className={classes.icon} aria-hidden>
                <MuiIcon icon={'error'} type={'outlined'} fontSize={'4rem'} color={'var(--text-danger)'} />
            </span>
            <Typography component={'p'} className={classes.title}>
                Upload failed
            </Typography>
            <Typography component={'p'} className={classes.message}>
                {message}
            </Typography>
            <div className={classes.actions}>
                <Button
                    type={'button'}
                    variant={'secondary'}
                    onClick={(e) => {
                        e.stopPropagation();
                        onTryAgain();
                    }}
                >
                    Try again
                </Button>
            </div>
        </div>
    );
};
